import {withModalProvider} from "../../../hoc/withModalProvider";
import {TemplateCreationButton as View, TemplateCreationButtonProps} from "./TemplateCreationButton";

export const TemplateCreationButton = withModalProvider<TemplateCreationButtonProps>(View);